export const mutations = {
    setPermissao(state, permissao) {
        state.permissao = permissao
    },
    setPermissoes(state, permissoes) {
        state.permissoes = permissoes
    },
    addPermissao(state, data){
        state.permissoes.push(data)
    },
    removePermissao(state, data){
        let index = state.permissoes.map(x => x.id).indexOf(data.id);
        state.permissoes.splice(index, 1)
    },
    setModalCadastrarPermissao(state, status) {
        state.modalCadastrarPermissao = status
    },
    setModalExcluirPermissao(state, status) {
        state.modalExcluirPermissao = status
    },
    setModalPesquisarPermissao(state, status) {
        state.modalPesquisarPermissao = status
    }
}

export default {}